// One entry point for printing a fee receipt from anywhere in the app. ReceiptPrintHost (mounted
// once in App) registers the handler that asks Classic (server PDF) or New (browser PDF).
// To retire the classic path later, change only ReceiptPrintHost.

type ReceiptPrintHandler = (receiptNo: number) => void;

let handler: ReceiptPrintHandler | null = null;

export const registerReceiptPrintHandler = (next: ReceiptPrintHandler | null) => {
  handler = next;
};

export const openReceiptPrint = (receiptNo: number, classicPrint: (receiptNo: number) => void) => {
  if (handler) handler(receiptNo);
  else classicPrint(receiptNo); // host not mounted: keep the classic behaviour
};
